import { render, staticRenderFns } from "./PerimeterStatus.vue?vue&type=template&id=44cc7928"
import script from "./PerimeterStatus.vue?vue&type=script&lang=js"
export * from "./PerimeterStatus.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports